// @flow
import * as React from 'react';

import {
  CalendarWorklogContainer,
  CalendarWorklogBody,
  CalendarWorklogBodyLeft,
  CalendarWorklogBodyRight,
  IssueKey,
  WorklogInfo,
  Avatar,
} from './styled';

const WorklogPlaceholder: React.StatelessFunctionalComponent<{}> = (): React.Node => (
  <CalendarWorklogContainer>
    <CalendarWorklogBody>
      <CalendarWorklogBodyLeft>
        <IssueKey />
        <WorklogInfo />
      </CalendarWorklogBodyLeft>
      <CalendarWorklogBodyRight>
        <Avatar />
      </CalendarWorklogBodyRight>
    </CalendarWorklogBody>
  </CalendarWorklogContainer>
);

export default WorklogPlaceholder;

